import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import {
  LucideAngularModule,
  BookOpen,
  Clock,
  Calendar,
  FileText,
  ArrowRight,
} from 'lucide-angular';
import {
  AssignmentPreview,
  STUDENT_ASSIGNMENT_THEME_COLOR,
} from '../../services/student-assignment.models';

@Component({
  selector: 'app-assignment-preview',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, DatePipe],
  templateUrl: './assignment-preview.html',
  styleUrl: './assignment-preview.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentPreviewComponent {
  @Input() preview: AssignmentPreview | null = null;
  @Input() isLoading = false;

  @Output() readonly start = new EventEmitter<void>();

  protected readonly themeColor = STUDENT_ASSIGNMENT_THEME_COLOR;

  protected readonly icons = {
    BookOpen,
    Clock,
    Calendar,
    FileText,
    ArrowRight,
  };

  protected formatTimeLimit(minutes: number): string {
    if (minutes === 0) {
      return 'No limit';
    }
    if (minutes < 60) {
      return `${minutes} minutes`;
    }
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (mins === 0) {
      return `${hours} hour${hours > 1 ? 's' : ''}`;
    }
    return `${hours} hour${hours > 1 ? 's' : ''} ${mins} min`;
  }

  protected onStart(): void {
    this.start.emit();
  }
}
